
const EndStep = () => {
    return (
        <p className="end-step">
            Votre message a été envoyé avec succès.<br />Je vous répondrai au plus vite.<br />Rémi Salas
        </p>
    )
}

export default EndStep